import { FeatureFlag } from '../FeatureFlag';

export const riskWidgetsShouldShowNewSymbolPicker = new FeatureFlag({
    key: 'risk-widgets-should-show-new-symbol-picker',
    defaultValue: false,
});
